interface Size {
  width?: number,
  height?: number,
}
const clientWidth = document.body.clientWidth;
const clientHeight = document.body.clientHeight;
/**
 * 放大镜自适应尺寸
 * 最小435，最大600，分界点 990
 */
export function getZoomSize(): Size {
  if (clientWidth < 990) {
    return {
      width: 435,
    }
  }
  return {
    width: 600,
  }
}
